export default {"src":"/_next/static/media/dog-champion.a4519b39.svg","height":272,"width":273};